import { type PropsWithChildren, useMemo, useState } from "react";
import {
  HotelFiltersContext,
  type HotelFiltersContextValue,
} from "./HotelFiltersContext";
import type { IHotelsFilters } from "../../types/interfaces";
import { deepCompareObjects } from "../../utils/deepCompareObjects";

export const HotelFiltersProvider = ({ children }: PropsWithChildren) => {
  const [defaultFilters, setDefaultFilters] =
    useState<HotelFiltersContextValue["defaultFilters"]>(null);
  const [filters, setFilters] =
    useState<HotelFiltersContextValue["filters"]>(null);

  const activeFilters = useMemo(() => {
    return defaultFilters && filters
      ? deepCompareObjects<IHotelsFilters>(defaultFilters, filters)
      : null;
  }, [defaultFilters, filters]);

  const contextValue = useMemo<HotelFiltersContextValue>(
    () => ({
      filters,
      defaultFilters,
      activeFilters,
      updateFilters: (value) => {
        if (filters === null) {
          setDefaultFilters(value);
        }
        setFilters(value);
      },
      resetFilters: () => {
        setFilters(null);
        setDefaultFilters(null);
      },
    }),
    [filters, defaultFilters, activeFilters],
  );

  return (
    <HotelFiltersContext.Provider value={contextValue}>
      {children}
    </HotelFiltersContext.Provider>
  );
};
